import {
  endOfDay,
  endOfMonth,
  endOfQuarter,
  endOfWeek,
  endOfYear,
  format,
  startOfDay,
  startOfMonth,
  startOfQuarter,
  startOfWeek,
  startOfYear,
  subDays,
  subMonths,
} from 'date-fns'

export type DatePreset =
  | 'today'
  | 'yesterday'
  | 'this-week'
  | 'this-month'
  | 'this-quarter'
  | 'this-year'
  | 'last-month'

export interface DateRange {
  from: string // yyyy-MM-dd
  to: string // yyyy-MM-dd
}

export function resolveDatePreset(preset: DatePreset): DateRange {
  const now = new Date()
  const fmt = (d: Date) => format(d, 'yyyy-MM-dd')

  switch (preset) {
    case 'today':
      return { from: fmt(startOfDay(now)), to: fmt(endOfDay(now)) }
    case 'yesterday': {
      const prev = subDays(now, 1)
      return { from: fmt(startOfDay(prev)), to: fmt(endOfDay(prev)) }
    }
    case 'this-week':
      return {
        from: fmt(startOfWeek(now, { weekStartsOn: 1 })),
        to: fmt(endOfWeek(now, { weekStartsOn: 1 })),
      }
    case 'this-month':
      return { from: fmt(startOfMonth(now)), to: fmt(endOfMonth(now)) }
    case 'this-quarter':
      return { from: fmt(startOfQuarter(now)), to: fmt(endOfQuarter(now)) }
    case 'this-year':
      return { from: fmt(startOfYear(now)), to: fmt(endOfYear(now)) }
    case 'last-month': {
      const prev = subMonths(now, 1)
      return { from: fmt(startOfMonth(prev)), to: fmt(endOfMonth(prev)) }
    }
  }
}
